import { defaultIconProps, IconProps } from './IconProps';

export const IconArrowTop: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M7.00004 12.8334L7.00004 1.16669M7.00004 1.16669L1.16671 7.00002M7.00004 1.16669L12.8334 7.00002"
      stroke={color}
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconArrowTop.defaultProps = defaultIconProps;
